import { ChangeDetectorRef } from '@angular/core';
import { CoordinatorService } from './coordinator.service';
import { SearchArchiveItem } from './search-archive-item';
import { ScriptHitset } from './script-hitset';

export type SEARCH_ITEM_HELP_DATA = {
    tag: string;
    value?: string;
    requiredLs?: string[];
    excludedLs?: string[];
};
export type SEARCH_HELP = {
    fieldLs: SEARCH_ITEM_HELP_DATA[];
    filterLs: SEARCH_ITEM_HELP_DATA[];
    selectionLs: SEARCH_ITEM_HELP_DATA[];
};
export class SearchArchive$ {
    private _searchArchiveMap = new Map<string, SearchArchiveItem>();

    private _searchCache = new Map<string, ScriptHitset>();

    constructor(private coords: CoordinatorService) {
        this.clear();
    }

    clearCacheHitset() {
        this._searchCache.clear();
    }

    getCacheHitset(sId: string) {
        return this._searchCache.get(sId) || null;
    }

    setCacheHitset(sId: string, hitset: ScriptHitset) {
        this._searchCache.set(sId, hitset);
    }
    searchLs(isAllUsers = false) {
        return Array.from(this._searchArchiveMap.values());
    }

    save({ title }: { title: string }) {
        const sai = new SearchArchiveItem(this.coords, {
            title,
            script: this.coords.search$.save(),
            runScript: this.coords.search$.saveRun(),
            help: this.coords.search$.saveHelp(),
        });

        // console.log('SAVE SEARCHRUN ', sai.runScript);
        this._searchArchiveMap.set(sai.id, sai);
        this._manifestStore();
    }

    delete(sai: SearchArchiveItem) {
        this._searchArchiveMap.delete(sai.id);
        this._manifestStore();
    }

    clear() {
        this._searchArchiveMap.clear();
    }

    load3(params: any) {
        if (!params) return;
        // console.log('SEARCH ARCHIVE LOAD3', params);
        params?.searchArchive.forEach((params: any) => {
            const sai = new SearchArchiveItem(this.coords, params);
            this._searchArchiveMap.set(sai.id, sai);
        });
    }

    private _manifestStore() {
        this.coords.manifest$.store({
            type: 'search-archive',
            id: `searchArchive_${this.coords.project$.currentId}`,
            valueMap: new Map<string, any[]>([['searchArchive', this._storeLs]]),
        });
    }

    private get _storeLs() {
        const ls: any[] = [];
        this._searchArchiveMap.forEach((v) => ls.push(v.data));
        return ls;
    }

    async import(ref: ChangeDetectorRef) {
        try {
            const data = await this.coords.filesystem$.pickJsonFile();
            if (!data.script || !data.runScript) return;
            const sai = new SearchArchiveItem(this.coords, data);

            this._searchArchiveMap.set(sai.id, sai);
            ref.markForCheck();
            this._manifestStore();
        } catch (e) {}
    }
}
